import AssignTo from "./styles";

export default AssignTo;
